export enum ModalActionTypes {
  ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO = 'ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO',
  ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO = 'ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO',
  ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES = 'ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES',
  ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES = 'ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES',
  ACTION_SHOW_MODAL_FILTRO_ESTUDANTE = 'ACTION_SHOW_MODAL_FILTRO_ESTUDANTE',
  ACTION_HIDE_MODAL_FILTRO_ESTUDANTE = 'ACTION_HIDE_MODAL_FILTRO_ESTUDANTE',
  ACTION_SHOW_MODAL_FILTRO_TURMA = 'ACTION_SHOW_MODAL_FILTRO_TURMA',
  ACTION_HIDE_MODAL_FILTRO_TURMA = 'ACTION_HIDE_MODAL_FILTRO_TURMA',
  ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA = 'ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA',
  ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA = 'ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA',
  ACTION_SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO = 'ACTION_SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO',
  ACTION_SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO = 'ACTION_SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO',
  ACTION_RESET_PROFESSOR_SELECIONADO_TELA_FILTRO = 'ACTION_RESET_PROFESSOR_SELECIONADO_TELA_FILTRO',
  ACTION_SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO = 'ACTION_SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO',
  ACTION_SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO = 'ACTION_SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO',
  ACTION_SHOW_MODAL_LEGADO = 'ACTION_SHOW_MODAL_LEGADO',
  ACTION_HIDE_MODAL_LEGADO = 'ACTION_HIDE_MODAL_LEGADO',
}
